<template>
  <div>
    <div style="margin-top: 10px;">invite others to join by sending this link:</div>
    <h3>https://fivechain.app/g/{{ $store.state.game.auth_token }}</h3>

    <div style="margin: 20px 0px;">
      <b v-if="isGameAdmin">Select teams and click 'Start' when all players have joined.</b>
      <b v-else>Please wait for {{ gameAdminName }} to start the game.</b>
    </div>

    <div v-for="player in gamePlayers" :key="'u' + player.id" style="margin-bottom: 5px;">
      <span :style="{ fontWeight: $store.state.player.id == player.id ? 'bold' : 'normal' }">{{ player.name }}&nbsp;</span>
      <select :value="player.color" :disabled="!isGameAdmin"
        @input="function (e) { setPlayerColor(player.id, e.target.value); }">
        <option value="*">Random</option>
        <option value="b">Blue</option>
        <option value="g">Green</option>
        <option value="r">Red</option>
        <option value="o">Observer</option>
      </select>
    </div>

    <label v-if="isGameAdmin" class="option">
      <input type="checkbox" v-model="showLastTile"> Show location of last tile played
    </label>

    <button v-if="isGameAdmin" @click="startButtonClicked">Start Game</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
const sharedUtils = require('../shared/utils.js');

export default {
  name: 'game-settings-screen',
  data () { return {
    colors: {},
    showLastTile: false,
  } },
  computed: {
    ...mapGetters(['isGameAdmin', 'gameAdminName', 'gamePlayers'])
  },
  methods: {
    setPlayerColor (playerId, playerColor) {
      this.$store.dispatch('setPlayerColor', { player: playerId, color: playerColor });
    },
    startButtonClicked () {
      var teams = {'*': [], o: [], r: [], g: [], b: []};
      for (let i = 0; i < this.gamePlayers.length; i++) {
        teams[this.gamePlayers[i].color].push(this.gamePlayers[i].id);
      }

      teams = sharedUtils.setupPlayersOnTeams(teams);
      if (typeof teams === 'string') { alert(teams); return; }
      
      this.$store.dispatch('startGame', { teams: teams, show_last_tile: this.showLastTile });
    }
  }
}
</script>

<style scoped>
h3 { margin: 4px; padding: 0px; }
button {
  text-transform: uppercase;
  border: 1px solid #999;
  font-size: 20px;
  padding: 10px 20px;
  margin: 20px 10px;
}
label.option {
  display: block;
  margin-top: 20px;
  cursor: pointer;
}
</style>
